import { createApp } from 'vue'
import CheckoutContent from './CheckoutContent'

const el = '.kb-component--checkout-content'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CheckoutContentDOM) => {
            const component = createApp(CheckoutContent).use(Store)
            component.mount(CheckoutContentDOM)
        })
    }
}
